import { Badge } from "@/components/ui/badge";
import type { ExpenseStatus } from "@/hooks/useExpenses";

interface ExpenseStatusBadgeProps {
  status: ExpenseStatus;
  isOverdue?: boolean;
}

export function ExpenseStatusBadge({ status, isOverdue }: ExpenseStatusBadgeProps) {
  if (status === "paid") {
    return <Badge variant="secondary">Paga</Badge>;
  }
  if (status === "cancelled") {
    return <Badge variant="outline">Cancelada</Badge>;
  }

  // open
  if (isOverdue) {
    return <Badge variant="destructive">Em atraso</Badge>;
  }
  return <Badge>Aberta</Badge>;
}
